import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import ShoppingBagRoundedIcon from '@mui/icons-material/ShoppingBagRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import TextureRoundedIcon from '@mui/icons-material/TextureRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Box } from '@mui/material';

const linkList = [
  { href: '/dashboard', title: 'Начало', icon: DashboardRoundedIcon },
  {
    href: '/products',
    title: 'Продукти',
    icon: Inventory2RoundedIcon,
    openInNewPage: true
  },
  { href: '/product-stats', title: 'Каталог', icon: AnalyticsRoundedIcon },
  {
    href: '/orders',
    title: 'Поръчки',
    icon: ShoppingBagRoundedIcon,
    openInNewPage: true
  },
  { href: '/materials', title: 'Материали', icon: TextureRoundedIcon },
  { href: '/reports', title: 'Справки', icon: DescriptionRoundedIcon },
  { href: '/stats', title: 'Статистика', icon: AssessmentRoundedIcon }
];

export default function VendorDashboardNavigation() {
  return (
    <Box component="nav" aria-label="Основна навигация" sx={{ display: 'flex', gap: 0.75 }}>
      {linkList.map((item) => (
        <Box
          key={item.href}
          component={NavLink}
          to={item.href}
          title={item.title}
          target={item.openInNewPage ? '_blank' : undefined}
          rel={item.openInNewPage ? 'noopener noreferrer' : undefined}
          sx={{
            alignItems: 'center',
            borderRadius: 2.5,
            color: 'text.secondary',
            display: 'flex',
            fontSize: 14,
            fontWeight: 650,
            gap: 0.75,
            px: { xs: 1.25, sm: 1.75 },
            py: 1,
            textDecoration: 'none',
            transition: 'all 160ms ease',
            '&:hover': { bgcolor: 'grey.100', color: 'text.primary' },
            '&.active': { bgcolor: 'primary.light', color: 'primary.dark' }
          }}
        >
          <item.icon sx={{ fontSize: 19 }} />
          <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
            {item.title}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
